import {ResponsiveModal} from '~library/organisms/ResponsiveModal';

export const ConfirmLeaveModalContainer = ({
  isFirstStep,
  isGuestStep,
  cancelLeave,
  saveAndLeave,
  leave,
  isEditingFlow,
}) => {
  switch (true) {
    case isFirstStep && isEditingFlow:
    case isEditingFlow:
      // this case is in use as of 12/10/2024
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title={isGuestStep ? 'Save & exit?' : 'Are you sure you want to exit?'}
          body={
            isGuestStep
              ? 'Your changes will be saved. Invitations will not be sent yet.'
              : 'Your unsaved changes to this invitation will be lost.'
          }
          secondaryAction={cancelLeave}
          secondaryText={isGuestStep ? 'Continue working' : 'No'}
          primaryAction={leave}
          primaryText={isGuestStep ? 'Save & exit' : 'Yes'}
          primaryQaId="modal-add-guests-exit-submit"
          secondaryQaId="modal-add-guests-exit-cancel"
          closeQaId="modal-add-guests-exit-close"
        />
      );
    case isFirstStep:
      // step 1
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title="Are you sure you want to exit?"
          body="You will lose your invitation progress. Please continue to Step 2 to save your invitation."
          secondaryAction={leave}
          secondaryText="Yes, I'll exit"
          primaryAction={cancelLeave}
          primaryText="No, I'll continue"
          titleQaId="createFlowUpsellModalLabel"
          bodyQaId="createFlowUpsellModalDescription"
          secondaryQaId="say-yes-btn"
          secondaryImpressionTracking
        />
      );
    default:
      // step 2, 3, 4
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title="Exit the Invitation Editor"
          body="We've saved your progress so you can finish creating your invitation later."
          secondaryAction={cancelLeave}
          secondaryText="Keep Editing"
          primaryAction={saveAndLeave}
          primaryText="Exit"
          titleQaId="createFlowUpsellModalLabel"
          bodyQaId="createFlowUpsellModalDescription"
          secondaryQaId="keep-editing-btn"
          primaryQaId="exit-btn"
          primaryImpressionTracking
        />
      );
  }
};
